module.exports = __webpack_public_path__ + "assets/img/jq_1.23b1cc32.png";